import React from "react";
import {
  Menu,
  MenuDivider,
  MenuItem,
  Tooltip,
  Position,
  NonIdealState,
  Intent,
  Button,
  Popover
} from "@blueprintjs/core";
import FadeIn from 'react-fade-in'
import ImageFullScreenable from './ImageFullscreenable'

class CreatePanelInterludesTable extends React.Component {
  handleDeleteInterlude = id => {
    const { onDeleteInterlude } = this.props;

    onDeleteInterlude(id);
  };

  handleChangeOrder = (currentIndex, newIndex) => {
    const { onChangeOrder } = this.props;

    onChangeOrder(currentIndex, newIndex);
  };

  orderButton = interludeId => {
    const { interludes } = this.props;
    const index = interludes.findIndex(i => i.id === interludeId);
    const orderMenu = (
      <Menu>
        <MenuDivider title="Change position" />
        {interludes.map((element, newIndex) => (
          <MenuItem
            key={newIndex}
            text={newIndex + 1}
            disabled={index === newIndex}
            onClick={() => this.handleChangeOrder(index, newIndex)}
          />
        ))}
      </Menu>
    );
    return (
      <Popover content={orderMenu} position={Position.LEFT}>
        <Button icon="changes" minimal={true} />
      </Popover>
    );
  };

  render() {
    const { interludes, deleting, onOpenDialog } = this.props;

    if (interludes.length <= 0)
      return (
        <FadeIn>
          <div>
            <NonIdealState
              icon="media"
              title="No Introduction Yet"
              description="You did not create introduction yet"
              action={
                <Button
                  intent={Intent.PRIMARY}
                  disabled={interludes.length >= 5}
                  rightIcon="add"
                  text="Add Introduction"
                  onClick={onOpenDialog}
                />
              }
            />
          </div>
        </FadeIn>
      );
    return (
      <FadeIn>

        <div>
          <div className="text-right">
            <Tooltip
              disabled={interludes.length < 20}
              content="You have reach the maximum amount of interludes"
              position={Position.TOP_LEFT}
            >
              <Button
                intent={Intent.PRIMARY}
                disabled={interludes.length >= 20}
                rightIcon="add"
                text="Add Introduction"
                style={{ marginBottom: "20px" }}
                onClick={onOpenDialog}
              />
            </Tooltip>
          </div>
          <div>
            <table className="bp3-html-table full-width">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>File</th>
                  <th>URL</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {interludes.map((i, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{i.name}</td>
                    <td>{i.file}</td>
                    <td>
                      {i.type === "VIDEO" && (
                        <a
                          // eslint-disable-next-line
                          target="_blank" href={i.downloadURL}>
                          <Button text="Voir la vidéo" />
                        </a>
                      )}
                      {i.type === "IMAGE" && (
                        <ImageFullScreenable
                          downloadURL={i.downloadURL}
                          index={i}
                        />
                      )}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {this.orderButton(i.id)}
                      <Button
                        icon="trash"
                        loading={deleting}
                        minimal={true}
                        onClick={() => this.handleDeleteInterlude(i.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </FadeIn>
    );
  }
}

export default CreatePanelInterludesTable;
